import { LoadingButton } from '@mui/lab';
import { Box, Button, DialogActions } from '@mui/material';
import React from 'react';
import { ExerciseType, Simulator } from '../types';

export interface CreateExerciseActionsProps {
  activeStep: number;
  finishLabel: string;
  handleBack: () => void;
  handleCancel: () => void;
  isLoading?: boolean;
  simulators: Simulator[];
  steps: string[];
  type?: ExerciseType;
}

const CreateExerciseActions = ({
  activeStep,
  finishLabel,
  handleBack,
  handleCancel,
  isLoading,
  simulators,
  steps,
  type,
}: CreateExerciseActionsProps) => {
  const isCautionStep = type === ExerciseType.Classroom && activeStep === 1;
  const hasNavigationLicense = simulators?.length > 0;

  return (
    <DialogActions sx={{ display: 'flex', gap: 1 }}>
      <Button onClick={handleCancel}>Cancel</Button>
      <Box sx={{ flex: '1 1 auto' }} />
      {activeStep > 0 && <Button onClick={handleBack}>Back</Button>}

      {isCautionStep && !hasNavigationLicense ? undefined : (
        <LoadingButton loading={isLoading} type="submit" variant="contained">
          {activeStep === steps.length - 1 ? finishLabel : 'Next'}
        </LoadingButton>
      )}
    </DialogActions>
  );
};

export default CreateExerciseActions;
